<div class="eva-3-cluster-gallery -eva-3-shadow-line-hover -eva-3-mb-lg" [ngClass]="{'cluster-high-heavy': highHeavyHighlight,'-eva-3-p-sm -eva-3-bc-brand-primary-4':favoriteHighlight}" (mouseover)="toggleHover()" (mouseleave)="toggleHover()">
  <div *ngIf="highHeavyHighlight" class="high-heavy-description -eva-3-bc-brand-primary-4 -eva-3-tc-white">
    <span class="eva-3-h5 -eva-3-tc-white -eva-3-mr-sm">{{ 'transfer-cluster.high.and.heavy.title' | translate }}</span> 
    <span class="eva-3-body-2 -eva-3-tc-white">{{ 'transfer-cluster.high.and.heavy.description' | translate}}</span>
  </div>
  <div *ngIf="favoriteHighlight" class="-eva-3-p-md -eva-3-center -eva-3-bc-brand-primary-4">
    <span class="eva-3-h4 -eva-3-tc-white ">{{ 'transfer-cluster.saved.featured' | translate }}</span>   
  </div>
  <div class="cluster-container">
    <div class="cluster-content">
      <div class="eva-3-row -no-gutter">
        <div class="col -sm-12 -md-5">
           <div class="favorite-container">
             <favorite-manager [item]="item" [cityGid]="cityGid"></favorite-manager>
           </div>
           <span class="eva-3-caption -eva-3-tc-gray-2 illustration">{{'transfer-cluster.image.illustration' | translate}}</span>
           <div class="cluster-image">
            <img [src]="item.image.url + '/240x178'" />
          </div>
          <span  class="provider-name">
            <span *ngIf="providerFeatureEnabled">
              <span  class="item-icon eva-3-icon-checkmark -eva-3-tc-green-3 -eva-3-mr-sm"></span><span class="eva-3-caption -eva-3-tc-gray-0"> {{item.provider}} </span>
            </span>  
            <span *ngIf="providerFeatureEnabled">
              <span  class="item-icon eva-3-icon-checkmark -eva-3-tc-green-3 -eva-3-mr-sm"> </span><span class="eva-3-caption -eva-3-tc-gray-0"> {{item.trackingId}} </span>                           
            </span>
            <span *ngIf="transferSupplierFeatureEnabled">
              <span  class="item-icon eva-3-icon-checkmark -eva-3-tc-green-3 -eva-3-mr-sm"></span><span class="eva-3-caption -eva-3-tc-gray-0"> {{item.providerInformation?.supplierName}} </span>              
            </span>  
          </span> 
         
        </div>
        
        <div class="col -sm-12 -md-7">
          <div class="cluster-description">
            <div class="transfer-detail-title" [ngClass]="{'-eva-3-pt-xlg': !isMobile}">
              <rating *ngIf="item.rating"
                      [product]="getProduct()"
                      [flow]="getFlow()"
                      [size]="'-sm'"
                      [rating]="item.rating"
                      class="-eva-3-mr-sm">
              </rating>
              <span class="transfer-type-title eva-3-h3 -eva-3-tc-gray-0">{{ 'transfer-cluster.service.type.' + item.transferServiceType | translate }}</span>
              <span class="transfer-detail-description eva-3-body-1 -eva-3-tc-gray-2 -eva-3-ellipsis">{{ item.transferDescription }}</span>
            </div>
            <ds-transfer-marquee [tags]="item.tags" [freeWifi]="item.freeWifi" [familiesRecommended]="item.familiesRecommended" [direct]="item.direct" [serviceType]="item.transferServiceType" [meetAndGreet]="item.meetAndGreet" [hovered]="hovered"></ds-transfer-marquee>
            <div class="travel-duration -eva-3-mt-sm">
              <span *ngIf="item.outwardSegment && item.outwardSegment.duration">
                <span class="eva-3-icon-time -eva-3-icon-xsm -eva-3-mr-xsm -eva-3-tc-gray-2"></span>
                <span class="eva-3-caption -eva-3-tc-gray-0">{{ 'transfer-cluster.duration' | translate }}: {{ item.outwardSegment.duration }}</span>    
              </span>
            </div>
            <div class="travel-duration -eva-3-mt-sm">
              <span *ngIf="item.maximumCapacity">
                <span class="eva-3-icon-user -eva-3-icon-xsm -eva-3-mr-xsm -eva-3-tc-gray-2"></span>
                <span class="eva-3-caption -eva-3-tc-gray-0">{{'transfer-cluster.capacity' | translate:{ number: item.maximumCapacity} }}</span>
              </span>
            </div>
            <div class="travel-calculation -eva-3-mt-sm">
              <span *ngIf="item.outwardSegment && item.outwardSegment.duration">
                <span class="eva-3-icon-airplane-going -eva-3-icon-xsm -eva-3-mr-xsm -eva-3-tc-gray-2"></span>
                <span class="eva-3-caption -eva-3-tc-gray-0">{{ 'transfer-cluster.calculation' | calculationText :item.coverage:item.outwardSegment.destination.type }} </span>    
              </span>
            </div>
            <div class="pickup eva-3-caption -eva-3-tc-gray-0 -eva-3-mt-sm" >
              <div *ngIf="item.outwardSegment.pickupDatetime">
                  <span>{{ item.outwardSegment.pickupText }}:</span>
                  <span class="-eva-3-bold"> {{ outwardTransferDate }}</span>
                  <div class="-eva-3-mt-sm -eva-3-tc-gray-2" *ngIf="item.outwardSegment.supplierMaximumWaitingTime">
                    {{ 'transfer-cluster.waiting.time' | translate }} {{ item.outwardSegment.supplierMaximumWaitingTime }}
                  </div> 
              </div>
              
              <div class="-eva-3-mt-sm" *ngIf="item.returnSegment && item.returnSegment.pickupDatetime">
                  <span>{{ item.returnSegment.pickupText }}:</span>
                  <span class="-eva-3-bold"> {{ returnTransferDate }}</span>
                  <div class="-eva-3-mt-sm -eva-3-tc-gray-2" *ngIf="item.returnSegment.supplierMaximumWaitingTime">
                    {{ 'transfer-cluster.waiting.time' | translate }} {{ item.returnSegment.supplierMaximumWaitingTime }}
                  </div> 
              </div>
            </div>
            <ds-cluster-amenities [baggageDetails]="item.baggageDetails"></ds-cluster-amenities>

          </div>
        </div>
      </div>
    </div>
    <div class="cluster-pricebox-container">
      <ds-cluster-pricebox [priceboxData]="priceboxData" [loyaltyMode]="loyaltyMode" [item]="item" [cityGid]="cityGid"></ds-cluster-pricebox>
    </div>
  </div>
</div>

